"use client"
import { Box, Typography, IconButton, Select, MenuItem, type SelectChangeEvent } from "@mui/material"
import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon } from "lucide-react"
import type { PaginationProps } from "./types"

export function Pagination({
    page,
    totalPages,
    rowsPerPage,
    totalItems,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions = [5, 10, 25, 50],
}: PaginationProps) {
    const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => {
        if (onRowsPerPageChange) {
            onRowsPerPageChange(Number(event.target.value))
        }
    }

    const isFirstPage = page === 1
    const isLastPage = page === totalPages

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                p: 2,
                borderTop: "1px solid #e0e0e0",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "33.33%",
                    justifyContent: "flex-start",
                }}
            >
                {onRowsPerPageChange ? (
                    <Select value={rowsPerPage} onChange={handleRowsPerPageChange} size="small" sx={{ mr: 1, height: 32 }}>
                        {rowsPerPageOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                ) : (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2" sx={{ mr: 1 }}>
                            {rowsPerPage}
                        </Typography>
                        <IconButton size="small">
                            <ChevronDownIcon size={16} />
                        </IconButton>
                    </Box>
                )}
                <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                    of {totalItems}
                </Typography>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "33.33%",
                    justifyContent: "center",
                }}
            >
                <IconButton size="small" disabled={isFirstPage} onClick={() => onPageChange(1)}>
                    <ChevronsLeftIcon size={16} />
                </IconButton>
                <IconButton size="small" disabled={isFirstPage} onClick={() => onPageChange(page - 1)}>
                    <ChevronLeftIcon size={16} />
                </IconButton>
                <Box
                    sx={{
                        mx: 1,
                        px: 2,
                        py: 0.5,
                        border: "1px solid #e0e0e0",
                        borderRadius: 1,
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="body2">{page}</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mx: 0.5 }}>
                        /
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {totalPages}
                    </Typography>
                </Box>
                <IconButton size="small" disabled={isLastPage} onClick={() => onPageChange(page + 1)}>
                    <ChevronRightIcon size={16} />
                </IconButton>
                <IconButton size="small" disabled={isLastPage} onClick={() => onPageChange(totalPages)}>
                    <ChevronsRightIcon size={16} />
                </IconButton>
            </Box>

            <Box sx={{ width: "33.33%" }}></Box>
        </Box>
    )
}

